<template>
    <div class="container">
        <div style="display: flex;width: 30%;align-items: center;">
           <el-breadcrumb separator="/">
                <el-breadcrumb-item v-for="item in list" :key="item.id">{{item.label}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="display:flex;align-items:center;">
            <!-- <div v-if="role==='个人'" style="margin-right:30px;color:rgb(146, 80, 230);cursor: pointer;">
                <span style="margin-right:20px;">剩余量：{{surplus}}</span>
                <span>已使用：{{used_num}}</span>
            </div> -->
            <div class="welcome">
            <el-dropdown>
                <span  class="el-dropdown-link welcomeBox">
                   <!-- <img src="../assets/img/圆形 1.png" alt=""> -->
                   <img src="../assets/img/用户.png" alt="">
                   <p v-if="role==='个人'">{{user_name}}</p>
                   <p v-else>{{organ_name}}</p>
                </span>
                <!-- user_name -->
                <el-dropdown-menu slot="dropdown" >
                    <!-- <el-dropdown-item disabled v-if="role==='个人'" class="personalInfoBox">
                        <div>机构账号：{{organ_name}}</div>
                    </el-dropdown-item> -->
                    <el-dropdown-item divided @click.native="goPersonal" v-if="role==='个人'">  <i class="el-icon-lock" style="color:rgb(146, 80, 230);"></i> 修改密码</el-dropdown-item>
                    <el-dropdown-item divided @click.native="logOut"> <i style="color:rgb(146, 80, 230);" class="el-icon-back"></i> 退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        </div>
        <el-dialog title="修改账号信息" :visible.sync="dialogVisible"  width="30%">
        <div style="width: 350px;margin-top: 20px">
            <t-form :data="form" :rules="rules" ref="form"  @submit="OrgaddUser" labelWidth="130px" labelAlign="right">
                <t-form-item label="原密码" name="password">
                    <t-input type="password" v-model="form.password"></t-input>
                </t-form-item>
                <t-form-item label="修改后密码" name="update_password">
                    <t-input type="password" v-model="form.update_password"></t-input>
                </t-form-item>
                <t-form-item >
                    <t-button theme="primary" type="submit" style="position: absolute;right: 70px;">确认</t-button>
                </t-form-item>
            </t-form>
        </div>
</el-dialog>

    </div>
</template>

<script>
export default {
    name: 'CrmMisComheader',

    data() {
        return {
            userName: '', // 用户名
            avatar: '', // 头像链接
            userRole: '', // 角色
            email: '', // 邮箱
            name:'',
            breadList: [], // 面包屑导航
            show:true,  // 左侧菜单收起展开
            organ_name:localStorage.getItem("organ_name"),
            user_name:localStorage.getItem("user_name"),
            surplus:null,//剩余量
            used_num:null,//已使用
            role:localStorage.getItem("role"),
            dialogVisible:false,
            form:{
               update_password:"",
               password:""
            },
            rules:{
                password: [{required: true,message: '请输入原密码',type: 'error'}],
                update_password: [{required: true,message: '请输入修改之后的密码',type: 'error'}],
            },
            list:[
                    {
                    label:'首页',
                    path:'/home'
                    }
                ]

        };
    },
    watch:{
         $route(to,from){
            this.addItem(to)
    }
        
    },
    created(){
        if(this.role === '个人'){
            this.list = [
                    {
                    label:'首页',
                    path:'/home'
                    }
                ]
        }else if(this.role === '机构'){
            this.list = [
                    {
                    label:'首页',
                    path:'/org'
                    }
                ]
        }
    //    this.fileNumInfo()
       
    },
    mounted() {
       

    },

    methods: {
        fileNumInfo(){
            this.$http({
                url:"api/user_file_num/",
                method:"GET",
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params:{
                     organ_name:localStorage.getItem("organ_name")
                }
            }).then(res=>{
                this.surplus = res.data.surplus
                this.used_num = res.data.used_num
              
            })
        },
        addItem(to){
            console.log(to)
        const obj ={
            label:to.meta.title,
            path:to.path
        }
        if(this.list[this.list.length-1].label=='首页'){
        let flag = false
            for(const{path} of this.list){
            if(path==obj.path){
                flag=true
            }
            }
            if(!flag){
            this.list.push(obj)
            }

        }else{
        this.list.splice(this.list.length-1,1)
        let flag = false
            for(const{path} of this.list){
            if(path==obj.path){
                flag=true
            }
            }
            if(!flag){
            this.list.push(obj)
            }
        }

   },
        // 退出登录
        logOut(){
            this.$confirm('是否退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '已退出登录!'
                });
                window.localStorage.removeItem("token")
                window.localStorage.removeItem("role")
                window.localStorage.removeItem("organ_name")
                this.$router.push({
                    name: "index",
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出登录'
                });          
            });
        },
        // 修改密码
        goPersonal(){
            this.dialogVisible = true
        },
        // 修改账号信息
        OrgaddUser(){
            this.$http({
                url:"api/user_core/",
                method:"POST",
                data:{
                    organ_name:localStorage.getItem("organ_name"),
                    password:this.form.password,
                    update_password:this.form.update_password
                }
            }).then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.dialogVisible = false
                    this.form.update_password=""
                    this.form.password=""
                }else{
                    this.$message.error(res.data.message);
                    this.dialogVisible = false
                    this.form.update_password=""
                    this.form.password=""
                }
            })
        },

         isHome(route) {
            return route.name === "index";
        },
        // getBreadcrumb() {
        //     let matched = this.$route.matched;
        //     // this.breadList = matched;
        // }
        
        
    },
};
</script>

<style lang="scss" scoped>
.t-button--variant-base.t-button--theme-primary:not(.t-is-disabled):not(.t-button--ghost) {
    background-color: rgb(146, 80, 230);
    border: 1px solid rgb(146, 80, 230);
    color: white;
}
.container{
    display: flex;
    // justify-content: right;
    justify-content: space-between;
    align-items: center;
    .logo{
        img{
            width: 140px;
            height: 70px;
        }    
    }
    .welcome{
        .welcomeBox{
            color: #000;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            height: 70px;
            padding: 5px;
            img{
                width: 30px;
                height: 30px;
                border-radius: 50%;
                margin-right: 10px;
            }
            .logOut{
                cursor: pointer;
            }
        }
    }
    .welcome:hover{
        // background-color: rgb(169, 213, 233);
    }
}
.infoImg{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 4px solid #fff;
}
.personalInfoBox{
    height: 50px;
    line-height: 50px;
    // background-color: azure;
    width: 350px;
    color: #000;
    font-size: 16px;
}
.personalInfo{
    text-align: center;
    padding: 20px 0;
}
.otherInfo :first-child{
    margin-right: 30px;
}
.icon{
    width: 25px;
    height: 25px;
    vertical-align: middle;
    margin-right: 10px;
}
</style>